import Papa from "papaparse";
import apiReport from "@/api/apiReport";
import { TransactionStatusTypes } from "./enums";
import apiTenant from "@/api/apiTenant";
// import { TransactionStatusTypes } from "./enums";

export default class CardPointeCompare {

    fileName = "";
    location = "";
    merchantId = "";
    minDate = "";
    maxDate = "";

    cardPointTotalSum = 0;
    incomeLogTotalSum = 0;

    cardPointTotalCount = 0;
    incomeLogTotalCount = 0;
    
    portalMissingTransactions = [];

    diffTotalSumByDate = [];
    diffTotalSumByDateTotal = 0;

    diffTotalSum = 0;

    portalNetTotal = 0;


    parseCSV(file) {
        return new Promise((resolve, reject) => {
            Papa.parse(file, {
                header: true,
                skipEmptyLines: true,
                complete: (results) => resolve(results.data),
                error: (err) => reject(err)
            });
        });
    }

    async process(file) {        

        // Read data from file
        this.fileName = file.name
        let cardPointeData = await this.parseCSV(file);
        
        // Get settings from file
        this.merchantId = cardPointeData[0].MID;
        this.location = cardPointeData[0].Location;
        const dates = cardPointeData.map((r) => new Date(r.Date));        
        this.minDate = new Date(Math.min(...dates)).yyyy_mm_dd();
        this.maxDate = new Date(Math.max(...dates)).yyyy_mm_dd();        

        // Get data from portal
        var siteInfo = await apiTenant.getByMerchantId(this.merchantId);
        var transactionData = await apiReport.orderTransactionsByMerchantId(this.merchantId, this.minDate, this.maxDate)                
        var incomeLogs = await this.addOrderIdToIncomeLog(transactionData)    

        // Filter out records from file data not used in calculating total
        const cardPointTotalRecords = cardPointeData.filter(t=> (t["Method"] != "VERIFY") && (t["Status"] != "VERIFIED" && t["Status"] != "DECLINED"));

        // Calculate CardPointe Total and Count
        this.cardPointTotalSum = cardPointTotalRecords.reduce((sum, item) => 
            {
                const amount = parseFloat(item["Amount"].replace(/[^0-9.-]+/g, ""));
                return sum + (isNaN(amount) ? 0 : amount);
            }, 0);            
        this.cardPointTotalSum = Math.round(this.cardPointTotalSum * 100) / 100;
        this.cardPointTotalCount = cardPointTotalRecords.length

        // Calculate Income Log Total and Count
        this.incomeLogTotalSum = Math.round(incomeLogs.reduce((sum, item) => sum + (item.creditCard || 0), 0) * 100) / 100;
        this.incomeLogTotalCount = incomeLogs.length

        // Calculate the Net Fee
        const portalNetFee = Math.round(incomeLogs.reduce((sum, item) => sum + (item.serviceFeeCreditCardAmount || 0), 0) * 100) / 100;
        this.portalNetTotal = this.incomeLogTotalSum - portalNetFee;
                
        // Find missing transactions not matching by order id in income log
        var portalMissingTransactionsTemp = []
        for (const cardPointeTransaction of cardPointTotalRecords) {
            const incomeLogRecord = incomeLogs.find(x => x.orderId == cardPointeTransaction["Order ID"])        

            if (incomeLogRecord == null) {
                cardPointeTransaction.id = cardPointeTransaction["Transaction #"]
                cardPointeTransaction.portalStatus = "missing"                
                portalMissingTransactionsTemp.push(cardPointeTransaction)
            } else if (incomeLogRecord.status != TransactionStatusTypes.Completed) {
                cardPointeTransaction.id = cardPointeTransaction["Transaction #"]
                cardPointeTransaction.portalStatus = incomeLogRecord.statusDisplay                
                portalMissingTransactionsTemp.push(cardPointeTransaction)
            }
        }

        // Try finding any of the missing income log transactions in the card reader logs
        if (portalMissingTransactionsTemp.length > 0 ) {
            var cardReaderData = await apiReport.cardReadLogsByMerchantId(this.merchantId, this.minDate, this.maxDate)
            for (const missing of portalMissingTransactionsTemp) {

                // Determine if this is a portal refund.
                // TODO: This is mostly a guess. Need to properly link in future.
                const portalRefund = (missing["Method"] == "REFUND" &&  missing["Front End"] == "API")

                if (!portalRefund){
                    var cardReaderLogRecord = cardReaderData.find(t => t.invoiceId == missing["Order ID"])

                    if (cardReaderLogRecord == null) {
                        cardReaderLogRecord = cardReaderData.find(t => t.referenceNumber == missing["Transaction #"].slice(1))
                    }

                    if (cardReaderLogRecord == null || !cardReaderLogRecord.isApproved) {
                        this.portalMissingTransactions.push(missing)
                    }
                }
            }
        }

        // Calculate total of missing transactions
        this.diffTotalSum = this.portalMissingTransactions.reduce((sum, item) => 
            {
                const amount = parseFloat(item["Amount"].replace(/[^0-9.-]+/g, ""));
                return sum + (isNaN(amount) ? 0 : amount);
            }, 0);            
        this.diffTotalSum = Math.round(this.diffTotalSum * 100) / 100;


 
        // Find CardPointe totals by data
        const cardPointTotalByDate = cardPointTotalRecords.reduce((acc, record) => {                
                const d = record["Date"].slice(0, 10);
                const [month, day, year] = d.split("/");
                const date = `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;

                acc[date] = (acc[date] || 0) + parseFloat(record["Amount"].replace(/[^0-9.-]+/g, ""));            
                return acc;
            }, {});
        

        // Find Income Log totals by data
        const portalTotalByDate = incomeLogs.reduce((acc, record) => {                
                const d = new Date(record.timestamp);
                const options = { timeZone: siteInfo.timezone };
                const day = new Intl.DateTimeFormat("en-CA", options).format(d);                
                acc[day] = (acc[day] || 0) + record.creditCard;            
                return acc;
            }, {});        


         // Find Days that do not match        
        for (const key in cardPointTotalByDate) {
            const cardPointTotalByDateValue = Math.round(cardPointTotalByDate[key] * 100) / 100;
            const portalTotalByDateValue = Math.round(portalTotalByDate[key] * 100) / 100;

            if (cardPointTotalByDateValue != portalTotalByDateValue)            
            this.diffTotalSumByDate.push({
                date: key,
                cardPointe: cardPointTotalByDateValue,
                portal: portalTotalByDateValue,
            })
        }  

        // Calculate total of mismatch dates
        this.diffTotalSumByDateTotal = this.diffTotalSumByDate.reduce((sum, item) => 
            {
                const amount = item.cardPointe - item.portal;
                return sum + (isNaN(amount) ? 0 : amount);
            }, 0);            
        this.diffTotalSumByDateTotal = Math.round(this.diffTotalSumByDateTotal * 100) / 100;    
         
    }

    async addOrderIdToIncomeLog(transactionData) {
        var incomeLogs = await apiReport.incomeLogsByMerchantId(this.merchantId, this.minDate, this.maxDate)
        
        incomeLogs.forEach(item => {
            if (item.orderId == null) {
                var transactionRecord = transactionData.find(t => t.piId == item.referenceId)
                if (transactionRecord == null) {
                    transactionRecord = transactionData.find(t => t.transactionRefId == item.referenceId)
                }

                if (transactionRecord != null) {
                    item.orderId = transactionRecord.voidId;
                    item.status = transactionRecord.status;
                    item.statusDisplay = transactionRecord.statusDisplay;
                } else {
                    item.orderId = null;                                        
                }        
            }
        });

        return incomeLogs;

    }

    getTotal(csvData) {
        const cardPointeData = Papa.parse(csvData, {
            header: true,
            skipEmptyLines: true
        }).data;

        // Filter out records from file data not used in calculating total
        const cardPointTotalRecords = cardPointeData.filter(t=> (t["Method"] != "VERIFY") && (t["Status"] != "VERIFIED" && t["Status"] != "DECLINED"));        

        let cardPointTotalSum = cardPointTotalRecords.reduce((sum, item) => 
            {                
                const amount = parseFloat(item["Amount"].replace(/[^0-9.-]+/g, ""));                
                return sum + (isNaN(amount) ? 0 : amount);
            }, 0);            
        cardPointTotalSum = Math.round(cardPointTotalSum * 100) / 100;
        console.log("cardPointTotalSum", cardPointTotalSum)
        return cardPointTotalSum;
         
    }
}
